
<div class="d-flex filter-header-rt floatinghead clearfix">
  <div class="rightside d-flex ml-auto" *ngIf="IsEmployee&&propertyList?.length>0&&permissionService.hasPermission(Modules.Employees,Actions.AssociationsEdit)">
    <div style="padding-left: 5px" *ngIf="!IsEditClicked">
      <button type="button" class="btn  btn-circle btn-green"
              tooltip="Bulk Update" triggers="mouseenter:mouseleave"
              placement="left" (click)="editUserExchanges()">
        <i aria-hidden="true" class="icofont icofont-ui-edit icon"></i>
      </button>
    </div>

  </div>
  <div class="rightside d-flex ml-auto margin-bottom-15" *ngIf="IsEditClicked">
    <label style="padding-top:17px;">Assign New Broker</label>
    <div style="padding-left: 5px; padding-top: 10px;">
      <label class="select">
        <select name="cmbBroker" class="form-control " [(ngModel)]="bulkBrokerId" (click)="onBrokerClick();" (change)="onBulkBrokerChange($event)">
          <option value="0">Select</option>
          <option *ngFor="let broker of brokers" [(ngValue)]="broker.Id">{{broker.Name}}</option>
        </select>
      </label>
    </div>
  </div>
</div>
<div class="cf"></div>
<div class="table-responsive table-fixed table-v-scroll margin0" style="width: 100%">
  <table class="table basictable row-border hover" datatable [dtOptions]="dtoptionsExchange">
    <thead>
      <tr>
        <th data-orderable="false" style="width:5px" [hidden]="!IsEditClicked">
          <label class="custom-checkbox withoutlabel">
            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>Select
          </label>
        </th>
        <th style="width:2px" [hidden]="!IsEditClicked">
        </th>
        <th>Exchange ID</th>
        <th data-orderable="false" [hidden]="!IsEmployee">Principal</th>
        <th>Offers</th>
        <th data-orderable="false" [hidden]="!IsEditClicked">Assign New Broker</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let property of propertyList;let i = index; trackBy: trackById">
        <td [hidden]="!IsEditClicked">
          <label class="custom-checkbox withoutlabel">
            <input type="checkbox" [(ngModel)]="property.IsSelected" (change)="onCheckboxChange($event,property.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
          </label>
        </td>
        <td [hidden]="!IsEditClicked"></td>
        <td class="sticky-left"><p><a href="javascript:void(0);" (click)="viewDetail(property.Guid)">{{property.ExchangeID }}</a></p></td>
        <td [hidden]="!IsEmployee">
          <p><a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{principal:property.UserGuid, prevroute:'1031 Exchanges', link : '1031-exchanges', activeTab:activeTab}">{{ property.PrincipalName }}</a></p>
          <p *ngIf="property.Phone">{{ property.Phone | phone }}</p>
          <p *ngIf="property.Email">{{property.Email}}</p>
        </td>
        <td>
          <p>{{property.Offers}}</p>
        </td>
        <td [hidden]="!IsEditClicked">
          <label class="select">
            <select name="cmbBroker" class="form-control " (change)="onBrokerChange($event,property)" [(ngModel)]="property.BrokerId">
              <option value="0">Select</option>
              <option *ngFor="let broker of brokers" value="{{broker.Id}}">{{broker.Name}}</option>
            </select>
          </label>
        </td>
      </tr>

    </tbody>
    <tfoot>
      <tr *ngIf="propertyList?.length == 0&&!IsDataProcessing">
        <td colspan="4" class="odd no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>

</div>
<div class="text-right margin-top-10" *ngIf="IsEditClicked">
  <button type="button" class="btn btn-default btn-lg" (click)="clearSelectedContact()">Cancel</button>
  <button class="btn btn-success  btn-lg" (click)="saveUserExchanges()">Save</button>
</div>



